module.exports = __webpack_public_path__ + "static/media/pos_receipt_original.8decb7e0.svg";